"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18n = require("../i18n");

var _reactI18next = require("react-i18next");

var _reactComponents = require("@cimpress/react-components");

var _UserLine = _interopRequireDefault(require("./UserLine"));

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UserRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserRow, _React$Component);

  function UserRow(props) {
    var _this;

    _classCallCheck(this, UserRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserRow).call(this, props));
    _this.state = {
      confirmDelete: false
    };
    return _this;
  }

  _createClass(UserRow, [{
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "renderRoles",
    value: function renderRoles() {
      var _this2 = this;

      var filteredRoles = this.props.allowedRoles.filter(function (a) {
        return _this2.props.user.roles.find(function (x) {
          return x === a.roleName;
        });
      });
      var readOnly = this.props.readOnly || this.props.isCurrentUser;

      var editIcon = _react.default.createElement(_reactStreamlineIcons.IconPencilCircle, {
        size: 'lg',
        color: readOnly ? _reactComponents.colors.platinum : _reactComponents.colors.shale
      });

      var deleteIcon = _react.default.createElement(_reactStreamlineIcons.IconRemoveCircle, {
        size: 'lg',
        color: readOnly ? _reactComponents.colors.platinum : _reactComponents.colors.shale
      });

      if (this.props.isCurrentUser) {
        editIcon = _react.default.createElement(_reactComponents.Tooltip, {
          contents: this.tt('editing_disabled_current_user')
        }, editIcon);
        deleteIcon = _react.default.createElement(_reactComponents.Tooltip, {
          contents: this.tt('deleting_disabled_current_user')
        }, deleteIcon);
      } else if (readOnly) {
        editIcon = _react.default.createElement(_reactComponents.Tooltip, {
          contents: this.tt('editing_disabled')
        }, editIcon);
        deleteIcon = _react.default.createElement(_reactComponents.Tooltip, {
          contents: this.tt('deleting_disabled')
        }, deleteIcon);
      } else {
        editIcon = _react.default.createElement(_reactComponents.Tooltip, {
          contents: this.tt('modify_user_roles')
        }, editIcon);
        deleteIcon = _react.default.createElement(_reactComponents.Tooltip, {
          contents: this.tt('delete_user')
        }, deleteIcon);
      }

      return _react.default.createElement("span", null, filteredRoles.length === 0 ? _react.default.createElement("em", {
        className: 'badge badge-default'
      }, this.tt('no_roles_defined')) : filteredRoles.map(function (a, i) {
        var style = a.isManagerRole ? 'badge badge-warning' : 'badge badge-info';
        return _react.default.createElement("span", {
          key: i
        }, _react.default.createElement("span", {
          className: style,
          style: {
            float: 'none'
          }
        }, a.roleCaption || a.roleName), "\xA0");
      }), "\xA0", _react.default.createElement("span", {
        className: "rcu-icon ".concat(readOnly ? 'rcu-icon disabled' : ''),
        onClick: readOnly ? null : function () {
          return _this2.props.onEditRolesClick();
        }
      }, editIcon), "\xA0\xA0", _react.default.createElement("span", {
        className: "rcu-icon ".concat(readOnly ? 'rcu-icon disabled' : ''),
        onClick: readOnly ? null : function () {
          return _this2.setState({
            confirmDelete: true
          });
        }
      }, deleteIcon));
    }
  }, {
    key: "renderConfirmDelete",
    value: function renderConfirmDelete() {
      var _this3 = this;

      var profile = this.props.user.profile || {};
      var userIdentifier = profile.name || profile.email || this.props.user.principal;
      return _react.default.createElement("tr", null, _react.default.createElement("td", {
        style: {
          paddingRight: '10px',
          paddingLeft: '10px',
          backgroundColor: '#fee'
        }
      }, _react.default.createElement("div", {
        className: 'clearfix'
      }, _react.default.createElement("h5", null, this.tt('remove_user_are_you_sure'), _react.default.createElement("br", null), userIdentifier), _react.default.createElement("div", {
        className: 'pull-right',
        align: "right"
      }, _react.default.createElement("button", {
        className: 'btn btn-sm btn-default',
        onClick: function onClick() {
          return _this3.setState({
            confirmDelete: false
          });
        }
      }, this.tt('button_cancel')), "\xA0", _react.default.createElement("button", {
        className: 'btn btn-sm btn-danger',
        onClick: function onClick() {
          return _this3.props.onDeleteUserClick();
        }
      }, this.tt('button_confirm'))))));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.confirmDelete) {
        return this.renderConfirmDelete();
      }

      return _react.default.createElement("tr", null, _react.default.createElement("td", {
        style: {
          paddingRight: '10px',
          paddingLeft: '10px'
        }
      }, _react.default.createElement("div", {
        className: 'row'
      }, _react.default.createElement("div", {
        className: 'col-sm-12'
      }, _react.default.createElement(_UserLine.default, {
        language: this.props.language,
        user: this.props.user,
        withAvatar: this.props.showAvatar,
        withUserType: true,
        withEmail: this.props.showEmail,
        withEmailAsTooltip: this.props.showEmailAsTooltip,
        withName: this.props.showName,
        isCurrentUser: this.props.isCurrentUser
      }))), _react.default.createElement("div", {
        className: 'row'
      }, _react.default.createElement("div", {
        className: 'col-sm-12',
        align: "right"
      }, this.renderRoles()))));
    }
  }]);

  return UserRow;
}(_react.default.Component);

UserRow.propTypes = {
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any,
  // roles to allow to assign to
  allowedRoles: _propTypes.default.array,
  // display
  language: _propTypes.default.string,
  currentUserSub: _propTypes.default.string,
  user: _propTypes.default.object.isRequired,
  isCurrentUser: _propTypes.default.bool.isRequired,
  onEditRolesClick: _propTypes.default.func.isRequired,
  onDeleteUserClick: _propTypes.default.func.isRequired,
  readOnly: _propTypes.default.bool,
  showAvatar: _propTypes.default.bool,
  showEmail: _propTypes.default.bool,
  showEmailAsTooltip: _propTypes.default.bool,
  showName: _propTypes.default.bool
};
UserRow.defaultProps = {
  language: 'eng',
  readOnly: false
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(UserRow);

exports.default = _default;